import React, { useState } from "react";
import Card from "components/card";
import Button from "components/button";
import { useToast } from "components/Toast";
import { updateCurrentUserPassword } from "services/users";
import { useNavigate } from "react-router-dom";

const ChangePassword: React.FC = () => {
  const [form, setForm] = useState({
    current_password: "",
    password: "",
    password_confirmation: "",
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((f) => ({ ...f, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    try {
      await updateCurrentUserPassword(form);
      toast.showSuccess?.("Password updated");
      navigate("/user/profile");
    } catch (err: any) {
      console.error(err);
      const msg = err.response?.data?.message || "Failed to update password";
      toast.showError?.(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card extra="w-full p-4">
      <h1 className="mb-4 text-2xl font-bold">Change Password</h1>
      <form onSubmit={handleSubmit} className="w-full max-w-md space-y-4">
        <input
          type="password"
          name="current_password"
          value={form.current_password}
          onChange={handleChange}
          className="input"
          placeholder="Current password"
          required
        />
        <input
          type="password"
          name="password"
          value={form.password}
          onChange={handleChange}
          className="input"
          placeholder="New password"
          required
        />
        <input
          type="password"
          name="password_confirmation"
          value={form.password_confirmation}
          onChange={handleChange}
          className="input"
          placeholder="Confirm new password"
          required
        />
        <div className="flex items-center gap-3">
          <Button type="submit" disabled={loading}>
            {loading ? "Updating..." : "Update Password"}
          </Button>
          <Button type="button" color="gray" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </form>
    </Card>
  );
};

export default ChangePassword;
